import type { Component } from 'vue'
import IconHome from '@/components/icons/IconHome.vue'
import IconTeams from '@/components/icons/IconTeams.vue'
import IconTrophy from '@/components/icons/IconTrophy.vue'
import IconUser from '@/components/icons/IconUser.vue'

export interface TabItem {
  /** nom de route (doit exister dans src/router/index.ts) */
  name: string
  /** label court affiché sous l'icône */
  label: string
  icon: Component
}

/**
 * Source de vérité de la tab bar.
 * Pour ajouter un 5e onglet : ajoute une route dans le router, une icône
 * dans components/icons/, puis une entrée ici. Rien d'autre à toucher.
 *
 * À noter : « Accueil » (route `home`) ouvre le **catalogue** des compétitions
 * (`CompetitionsView`) — c'est là qu'on choisit son univers — tandis que
 * « Compétition » (route `competition`) ouvre la page de la compétition
 * sélectionnée (`CompetitionView`).
 */
export const tabs: TabItem[] = [
  { name: 'home', label: 'Accueil', icon: IconHome },
  { name: 'competition', label: 'Compétition', icon: IconTrophy },
  { name: 'teams', label: 'Équipes', icon: IconTeams },
  { name: 'profile', label: 'Profil', icon: IconUser },
]
